/* eslint-disable arrow-parens */
/* eslint-disable react/prop-types */
import { forwardRef, JSXElementConstructor, ReactElement, useCallback, useContext, useMemo } from "react";
import { api } from "../../../../utils/api";
import { trackPromise } from "react-promise-tracker";

import { AuthContext, ThemeContext } from "../../../../contexts";

import {
	Dialog,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Slide,
	IconButton,
	DialogActions,
	Button,
	Grid,
	TextField
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";

import CloseIcon from "@mui/icons-material/Close";

import "./customEnrollmentDisclaimerDialog.css";
import { CustomFilledInput, CustomInput } from "../../CustomInput";
import { member } from "../../../../utils/api/member/member";

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const CustomEnrollmentDisclaimerDialog = ({
	enrollmentDisclaimerDialogProps,
	handleCloseDisclaimerDialog,
	handleEscapeCloseDisclaimerDialog,
	emailDisclaimer,
	setEmailDisclaimer,
	plan_code
}) => {
	const { theme } = useContext(ThemeContext);
	const { member } = useContext(AuthContext);
	const urlSearchParams = useMemo(() => new URLSearchParams(location.search), []);
	const { openDialog, title, content, importantTitle, importantContent, inputFields, actions } =
		enrollmentDisclaimerDialogProps;

	const handleDisclaimerEmailChange = useCallback(
		(event) => {
			const { name, value } = event.target;
			setEmailDisclaimer(value);
		},
		[setEmailDisclaimer]
	);

	const handleGetDisclaimerClick = useCallback(async () => {
		if (!member) {
			return;
		}
		const step = urlSearchParams.get("step");
		if (!emailDisclaimer || !step) {
			alert("Please enter an valid email id");
			return;
		}
		let _planName;
		switch (step) {
			case "Cancer":
				_planName = "Cancer";
				break;
			case "Whole life":
				_planName = "Whole life";
				break;
			case "Critical Illness":
				_planName = "Critical Illness";
				break;
			case "Short Term Disability":
				_planName = "Short Term Disability";
				break;
			case "Accident":
				_planName = "Accident";
				break;
			case "Hospital Indemnity":
				_planName = "Hospital Indemnity";
				break;
			case "Group Life Indemnity":
				_planName = "Group Life Indemnity";
				break;
			case "Family Protection":
				_planName = "Family Protection";
				break;
			case "Doc and Rx":
				_planName = "Doc and Rx";
				break;
			case "Vision":
				_planName = "Vision";
				break;
			case "Term Life Coverage":
				_planName = "Term Life Coverage";
				break;
			case "Dental":
				_planName = "Dental";
				break;
		}
		const payload = {
			group_number: member?.group_number,
			email: emailDisclaimer,
			plan_name: _planName,
			plan_code: plan_code,
			emailType: "declaimer",
			// filename: "disclaimerFile.txt",
			is_disclaimer: true,
			subject: "Disclaimer Email Brochure"
		};
		try {
			const response = await trackPromise(api.email.emailBrochureVEBEnrollment(payload));

			if (response === 200) {
				alert("Brochure is successfully sent");
			} else {
				alert("Brochure not found");
			}
		} catch (error) {
			console.error(error);
			alert("Something went wrong");
		} finally {
			handleCloseDisclaimerDialog(); // ALWAYS closes
		}
	}, [emailDisclaimer, handleCloseDisclaimerDialog, urlSearchParams, member]);

	return (
		<Dialog
			style={{ zIndex: 5000 }}
			open={openDialog}
			onClose={handleCloseDisclaimerDialog}
			onKeyDown={handleEscapeCloseDisclaimerDialog}
			TransitionComponent={Transition}
			keepMounted
			aria-labelledby="alert-dialog-slide-title"
			aria-describedby="alert-dialog-slide-description"
			className="disclaimer-dialog-container"
		>
			<DialogTitle id="alert-dialog-slide-title">
				<div className="custom-dialog-title">{title}</div>
			</DialogTitle>
			<IconButton
				aria-label="close"
				onClick={handleCloseDisclaimerDialog}
				sx={{
					position: "absolute",
					right: 8,
					top: 8,
					color: (theme) => theme.palette.grey[500]
				}}
			>
				<CloseIcon />
			</IconButton>
			<DialogContent className="custom-discliamer-dialog-content-container">
				<DialogContentText id="alert-dialog-slide-description">
					<div className="custom-dialog-content">{content}</div>
				</DialogContentText>
				{importantContent && importantContent ? (
					<div className="disclaimer-dialog-content-container">
						<span className="important-content-title">{importantTitle}:</span>
						<span className="important-content">{importantContent}</span>
					</div>
				) : null}
				<div className="discalimer-dialog-action-field-container">
					<Grid container spacing={1}>
						<Grid item xs={6} sm={6} md={8} lg={8} xl={8}>
							{inputFields.map((inputField, index) => {
								const { name, value, placeholder } = inputField;
								return (
									<TextField
										// id="first-name-input"
										// className="form-field"
										name={name}
										value={emailDisclaimer}
										onChange={(event) => handleDisclaimerEmailChange(event)}
										variant="outlined"
										key={index}
										placeholder={placeholder}
										style={{ width: "100%", padding: 0, cursor: "pointer" }}
									/>
								);
							})}
						</Grid>
						<Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
							{actions.map((action, index) => {
								const { label, callback } = action;
								return (
									<Button
										variant="contained"
										style={{
											backgroundColor: theme.button.background_color,
											color: theme.button.color
										}}
										onClick={handleGetDisclaimerClick}
										key={index}
										className="enroll-disclaimer-action-btn"
									>
										{label}
									</Button>
								);
							})}
						</Grid>
					</Grid>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default CustomEnrollmentDisclaimerDialog;
